import { makeStyles } from '@material-ui/core';

export const useListItemStyles = makeStyles((theme) => ({
  ordinal: {
    minWidth: '30px',
    height: '30px',
    lineHeight: '25px',
    borderRadius: '50%',
    textAlign: 'center',
    fontSize: '20px',
    border: '2px solid',
    color: theme.palette.primary.main,
    marginRight: '10px',
  },
}));
